import clsx from 'clsx';

import logoDark from '@/assets/images/logo_alt.svg';
import logoLight from '@/assets/images/logo_alt_black.svg';

export function Logo({ logo }: { logo?: string }) {
  if (!logo) {
    return (
      <>
        <LogoImg
          src={logoDark}
          className="hidden th-highcontrast:!block th-dark:!block"
          alt="Portainer"
        />
        <LogoImg
          src={logoLight}
          className="block th-highcontrast:hidden th-dark:hidden"
          alt="Portainer"
        />
      </>
    );
  }

  return <LogoImg src={logo} alt="Portainer" />;
}

export function LogoImg({
  src,
  alt,
  className,
}: {
  src: string;
  alt: string;
  className?: string;
}) {
  return (
    <img
      src={src}
      className={clsx('m-auth relative mb-2 block w-[240px]', className)}
      alt={alt}
    />
  );
}
